import { useApi } from '@gravitate-js/the-armory'
import { useQuery } from '@tanstack/react-query'
import { getAPIURL } from '@utils/api'

/**
 * This is ugly as hell, but it gives us nice auto-complete until we have TS rolling!
 * No type safety on the query data though :(
 *
 * The current implementation only supports EPs that end with /metadata. For example:
 * Passing order/backhaul_metadata as a category will not work.
 *
 * @typedef {('order'|'store'|'store/tank'|'store/tank/supply'|'tank_strategy'|'product'|'counterparty'|'location'|'supply_zone'|'event'|'trailer'|'tractor'|'truck_rate'|'driver'|'freight_surcharge'|'store_monitor'|'bol'|'role'|'driver_analytics'|'price_management'| 'payroll/driver_rate')} MetadataCategory
 */

/**
 * @description Returns a metadata query for the given category
 * @param {MetadataCategory} category - The metadata category to fetch
 * @example
 * // returns UseQueryResult<any, unknown>
 * const {data: storeMetadata} = useMetadata('store')
 */
export const useMetadata = (category) => {
  const api = useApi({ baseURLOverride: getAPIURL() })
  const url = `${category}/metadata`
  const getMetadataQuery = useQuery({ queryKey: [url], queryFn: () => api.post(url), refetchOnWindowFocus: false })
  return getMetadataQuery
}
